"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ChildApp_1 = require("./ChildApp");
exports.ChildApp = ChildApp_1.default;
var ChildAppReactComponent_1 = require("./ChildAppReactComponent");
exports.ChildAppReactComponent = ChildAppReactComponent_1.default;
var ParentApp_1 = require("./ParentApp");
exports.ParentApp = ParentApp_1.default;
//# sourceMappingURL=index.js.map